import React from 'react'
import { func, object } from 'prop-types'

import Input from 'coact/Input'

function InputSetting (props) {
  const { fillGrids, spliter, hideWhenMethodIsDot, style } = props
  return (
    <div>
      <span>S:</span>
      <Input type="number" {...spliter(props)('s1')} />
      <span style={hideWhenMethodIsDot}>
        <span>~</span>
        <Input type="number" style={hideWhenMethodIsDot} {...spliter(props)('s2')} />
      </span>
      <span>, C:</span>
      <Input type="number" {...spliter(props)('c1')} />
      <span style={hideWhenMethodIsDot}>
        <span>~</span>
        <Input type="number" style={hideWhenMethodIsDot} {...spliter(props)('c2')} />
      </span>
      <div className={style.setting} onClick={fillGrids}>填滿</div>
    </div>
  )
}
InputSetting.propTypes = {
  fillGrids: func.isRequired,
  spliter: func.isRequired,
  hideWhenMethodIsDot: object,
  style: object.isRequired,
}

export default InputSetting



// WEBPACK FOOTER //
// ./src/components/RangeEditor/InputSetting/InputSetting.jsx